class JqueryClassFaker {
	constructor(initialClassList) {
		this.classes = new Map();
		this.finalValue = '';
		if(initialClassList) {
			if(initialClassList instanceof JqueryClassFaker) {
				initialClassList.classes.forEach((value, key) => {
					this.addClass(key, value);
				});
			}
			else {
				initialClassList.split(' ').forEach((className) => {
					this.addClass(className);
				});
			}
		}
	}

	hasClass(entry) {
		return this.classes.has(entry);
	}

	addClass(entry, value) {
		this.classes.set(entry, value);
		if(value) {
			this.finalValue = value;
		}
		return this;
	}

	toggleClass(entry, booleanValue) {
		booleanValue ? this.addClass(entry) : this.removeClass(entry);
	}

	removeClass(entry) {
		this.classes.delete(entry);
		return this;
	}

	toString() {
		return Array.from(this.classes.keys()).join(' ');
	}

	getFinalValue() {
		return this.finalValue;
	}

	keys() {
		return this.classes.keys();
	}

	[Symbol.iterator]() {
		return this.classes.entries();
	}
}

JqueryClassFaker.prototype.push = JqueryClassFaker.prototype.addClass;
JqueryClassFaker.prototype.add = JqueryClassFaker.prototype.addClass;
JqueryClassFaker.prototype.set = JqueryClassFaker.prototype.addClass;
JqueryClassFaker.prototype.delete = JqueryClassFaker.prototype.removeClass;

export { JqueryClassFaker };